<template>
  <div 
    v-show="active"
    :class="{'is-active': active}"
    class="ec-modal ec-debug-tools-modal">
    <div 
      class="ec-modal-main is-loading animated fadeIn blue-border">
      <a 
        href="#"
        class="close-icon modal-close"
        @click.stop.prevent="closeModal" /> 
      <div class="ec-modal-headline">AdminDebugTools</div>
      <div class="ec-modal-form-wrapper">
        <div class="ec-modal-radio">
          <div>Additional Information</div>
          <div>
            <input 
              id="informations-true" 
              :value="true"
              v-model="settings.informations"
              type="radio"
              name="informations">
            <label for="informations-true"> On</label> 
            <input 
              id="informations-false" 
              :value="false"
              v-model="settings.informations"
              type="radio" 
              name="informations">
            <label for="informations-false"> Off</label>
          </div>
        </div>
        <div class="debug-tools-help">
          Diese Funktion blendet zusätzliche Informationen zu Fragen & Antworten ein.
        </div>
        <div class="ec-modal-radio">
          <div>Disabled Blacklists & Prefills</div>
          <div>
            <input 
              id="blacklist-true"
              :value="true"
              v-model="settings.hiddenQuestions"
              type="radio"
              name="hiddenable">
            <label for="blacklist-true"> On</label>
            <input 
              id="blacklist-false"
              :value="false"
              v-model="settings.hiddenQuestions"
              type="radio"
              name="hiddenable">
            <label for="blacklist-false"> Off</label>
          </div>
        </div>
        <div class="debug-tools-help">
          Diese Funktion zeigt alle Fragen im System an.
          Bitte nutze sie ausschließlich für belanglose Kalkulationen.
        </div>
      </div>
      <div class="ec-modal-btn-wrapper">
        <button 
          id="ec-modal-variable-ok" 
          class="ec-modal-btn-ok btn is-blue btn-has-max-width"
          @click.prevent="sendChangeSettings">Speichern</button>
      </div>
      <div
        v-show="loading"
        class="ec-modal-loader"/>
    </div>
  </div>
</template>
<style scoped>
  .debug-tools-help {
     color: #9E9E9E
  }
</style>
<script>
import { merge } from 'lodash'
import Modal from "./Modal.mixin.vue"

export default {
  mixins: [Modal],
  data: function() {return {
    settings: {
      hiddenQuestions: true,
      informations: true,
    },
    active: false,
    loading: true,
  }},
  watch: {
    'settings.hiddenQuestions': {
      handler: function(value) {
        this.$store.debug.ignoreRdyToSend = value
      },
      immediate: true
    }
  },
  mounted() {
    const debugToolsBtn = document.getElementById("debugtools-btn")
    debugToolsBtn.addEventListener('click', () => {
      this.active = true
    })

    axios.get('/debugtools/current-settings')
      .then((response) => {
        this.settings = merge(this.settings, response.data)
        this.loading = false
      })
      .catch(function (error) {
        console.log(error)
    })
  },
  methods: {
    sendChangeSettings() {
      this.loading = true
      axios.post('/debugtools/settings', {
        settings: this.settings
      })
      .then(() => {
        this.loading = false
        this.closeModal()
      })
      .catch(function (error) {
        console.log(error)
      })
    }
  },
  
}
</script>

